import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

interface Filter {
    date: Date;
}

@Injectable({ providedIn: 'root' })

export class AdsService {

    constructor(private httpClient: HttpClient) { }

    getAds(filter: Filter) {
        return this.httpClient.post<any>('api_endpoint' + `/ads/getAds`, { filter });
    }


}